<template>
    <div>
        {{ $t('notification.driveFileAdded', { 
            actor: $_.get(activity, 'actorUser.name'), 
            fileName: $_.get(activity, 'payload.fileName')
        }) }}
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "DriveFileAdded",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>

